// no imports

// Color conversion constants
var epsilon = 216.0 / 24389.0;
var kappa = 24389.0 / 27.0;

// D65 (CIE 1931) white reference values: daylight, sRGB, Adobe-RGB
var whiteReference = {
    X: 95.047,
    Y: 100.000,
    Z: 108.883
}

// Calculates the Delta-E distance between two colors given in RGB
function deltaE(color1Rgb, color2Rgb) {
    var color1Lab = convertRgbToLab(color1Rgb);
    var color2Lab = convertRgbToLab(color2Rgb);
    return cie2000Difference(color1Lab, color2Lab);
}

// Implements the CIE2000 method of Delta-E: https://en.wikipedia.org/wiki/Color_difference#CIEDE2000
function cie2000Difference(color1Lab, color2Lab) {
    // parametric weighting factors usually set to unity
    var kL = 1.0;
    var kC = 1.0;
    var kH = 1.0;
    var degrees360InRadians = degreesToRadians(360.0);
    var degrees180InRadians = degreesToRadians(180.0);
    var pow25To7 = Math.pow(25, 7);


    // Step 1

    var c1 = Math.sqrt((color1Lab.A * color1Lab.A) + (color1Lab.B * color1Lab.B));
    var c2 = Math.sqrt((color2Lab.A * color2Lab.A) + (color2Lab.B * color2Lab.B));

    var barC = (c1 + c2) / 2.0;
    var g = 0.5 * (1 - Math.sqrt(Math.pow(barC, 7) / (Math.pow(barC, 7) + pow25To7)));

    var a1Prime = (1.0 + g) * color1Lab.A;
    var a2Prime = (1.0 + g) * color2Lab.A;

    var cPrime1 = Math.sqrt((a1Prime * a1Prime) + (color1Lab.B * color1Lab.B));
    var cPrime2 = Math.sqrt((a2Prime * a2Prime) + (color2Lab.B * color2Lab.B));

    var hPrime1;
    if (color1Lab.B === 0 && a1Prime === 0) {
        hPrime1 = 0.0;
    } else {
        hPrime1 = Math.atan2(color1Lab.B, a1Prime);
        if (hPrime1 < 0) {
            hPrime1 += degrees360InRadians;
        }
    }

    var hPrime2;
    if (color2Lab.B === 0 && a2Prime === 0) {
        hPrime2 = 0.0;
    } else {
        hPrime2 = Math.atan2(color2Lab.B, a2Prime);
        if (hPrime2 < 0) {
            hPrime2 += degrees360InRadians;
        }
    }


    // Step 2

    var deltaLPrime = color2Lab.L - color1Lab.L;
    var deltaCPrime = cPrime2 - cPrime1;

    var deltaHPrime;
    var cPrimeProduct = cPrime1 * cPrime2;
    if (cPrimeProduct === 0) {
        deltaHPrime = 0;
    } else {
        deltaHPrime = hPrime2 - hPrime1;

        if (deltaHPrime < -degrees180InRadians) {
            deltaHPrime += degrees360InRadians;
        } else if (deltaHPrime > degrees180InRadians) {
            deltaHPrime -= degrees360InRadians;
        }
    }
    deltaHPrime = 2.0 * Math.sqrt(cPrimeProduct) * Math.sin(deltaHPrime / 2.0);


    // Step 3

    var barLPrime = (color1Lab.L + color2Lab.L) / 2.0;
    var barCPrime = (cPrime1 + cPrime2) / 2.0;
    var hPrimeSum = hPrime1 + hPrime2;
    var barHPrime;

    if (cPrime1 * cPrime1 === 0) {
        barHPrime = hPrimeSum;
    } else {
        if (Math.abs(hPrime1 - hPrime2) <= degrees180InRadians) {
            barHPrime = hPrimeSum / 2.0;
        } else if (hPrimeSum < degrees360InRadians) {
            barHPrime = (hPrimeSum + degrees360InRadians) / 2.0;
        } else {
            barHPrime = (hPrimeSum - degrees360InRadians) / 2.0;
        }
    }

    var t = 1.0 - (0.17 * Math.cos(barHPrime - degreesToRadians(30.0))) +
        (0.24 * Math.cos(2.0 * barHPrime)) +
        (0.32 * Math.cos((3.0 * barHPrime) + degreesToRadians(6.0))) -
        (0.20 * Math.cos((4.0 * barHPrime) - degreesToRadians(63.0)));
    var deltaTheta = degreesToRadians(30.0) * Math.exp(-Math.pow((barHPrime - degreesToRadians(275.0)) / degreesToRadians(25.0), 2.0));

    var rC = 2.0 * Math.sqrt(Math.pow(barCPrime, 7.0) / (Math.pow(barCPrime, 7.0) + pow25To7));
    var sL = 1 + ((0.015 * Math.pow(barLPrime - 50.0, 2.0)) / Math.sqrt(20 + Math.pow(barLPrime - 50.0, 2.0)));
    var sC = 1 + (0.045 * barCPrime);
    var sH = 1 + (0.015 * barCPrime * t);
    var rT = (-Math.sin(2.0 * deltaTheta)) * rC;

    var deltaE = Math.sqrt(Math.pow(deltaLPrime / (kL * sL), 2.0) +
        Math.pow(deltaCPrime / (kC * sC), 2.0) +
        Math.pow(deltaHPrime / (kH * sH), 2.0) +
        (rT * (deltaCPrime / (kC * sC)) * (deltaHPrime / (kH * sH))));
    return deltaE;
}

function degreesToRadians(degrees) {
    return (degrees * (Math.PI / 180.0));
}

function convertRgbToLab(colorRgb) {
    var colorXyz = convertRgbToXyz(colorRgb);
    return convertXyzToLab(colorXyz);
}

function convertRgbToXyz(colorRgb) {
    var r = pivotRgb(colorRgb.R / 255.0);
    var g = pivotRgb(colorRgb.G / 255.0);
    var b = pivotRgb(colorRgb.B / 255.0);

    // Observer = 2°, Illuminant = D65
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;

    return {
        X: x,
        Y: y,
        Z: z
    }
}

function convertXyzToLab(colorXyz)
{
    var x = pivotXyz(colorXyz.X / whiteReference.X);
    var y = pivotXyz(colorXyz.Y / whiteReference.Y);
    var z = pivotXyz(colorXyz.Z / whiteReference.Z);

    return {
        L: Math.max(0, 116 * y - 16),
        A: 500 * (x - y),
        B: 200 * (y - z)
    };
}

function pivotRgb(n) {
    if (n > 0.04045) {
        return Math.pow((n + 0.055) / 1.055, 2.4) * 100;
    }
    return (n / 12.92) * 100;
}

function pivotXyz(n) {
    if (n > epsilon) {
        return Math.pow(n, (1.0 / 3.0));
    }
    return (kappa * n) + (16 / 116);
}

const DeltaE = deltaE;
export default { DeltaE };